import Field from '../Field';

class Email extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    this.value.forEach((val, index) => {
      if (val === undefined || val === null) {
        val = '';
      }

      this.setValue(val.toLowerCase(), index);
      this.setDisplayValue(val.toLowerCase(), index);
    });

    return this;
  }

  validate() {
    super.validate();
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9]+$/i;

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      if (!regex.test(val)) {
        this.invalidate('Invalid email address.', index);
      }
    });

    return this.isValid();
  }
}

export default Email;
